// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// Core Libs
import {formatDate} from '../../lib/core/date';

// Containers
import withFormField from '../../containers/with-form-field';

// Styles
import './input.scss';

class Input extends Component {
    inputRef = React.createRef();

    state = {
        caretPosition: undefined,
    };

    componentDidUpdate() {
        const {caretPosition} = this.state;
        const {inputType= 'text'} = this.props;

        if (inputType === 'text' && this.inputRef.current && (caretPosition || caretPosition === 0)) {
            this.inputRef.current.setSelectionRange(caretPosition, caretPosition);
        }
    }

    getClass() {
        const {className, inputType= 'text'} = this.props;

        return classnames(
            {
                input: true,
                'input--date': inputType === 'date',
            },
            className
        );
    }

    getDatetimeProps() {
        const {inputType = 'text', value} = this.props;

        return inputType === 'datetime'
            ? {
                  inputType: 'date',
                  value: formatDate(value, 'YYYY-MM-DD') || '',
              }
            : null;
    }

    getNumberProps() {
        const {inputType = 'text'} = this.props;

        return inputType === 'number'
            ? {
                  min: 0,
                  step: 1,
              }
            : null;
    }

    onChange = (event) => {
        const {onChange} = this.props;

        event.persist();
        this.setState({caretPosition: event.target.selectionStart});

        onChange(event);
    };

    getInputProps() {
        const {disableAutofill, disabled, id, name, onBlur, onClick, placeholder, size, inputType = 'text', value} = this.props;
        let fieldValue;
        if (inputType === 'number' && value !== '' && value !== undefined && value !== null) {
            fieldValue = +value;
        } else if (value !== undefined) {
            fieldValue = value;
        } else {
            fieldValue = '';
        }

        return {
            autoComplete: disableAutofill ? 'new-password' : undefined,
            className: this.getClass(),
            id,
            disabled,
            name: disableAutofill ? undefined : name,
            onBlur,
            onChange: this.onChange,
            onClick,
            onKeyPress: this.handleKeyPress,
            placeholder,
            ref: this.inputRef,
            size,
            type: inputType,
            value: fieldValue,
            ...this.getDatetimeProps(),
            ...this.getNumberProps(),
        };
    }

    handleKeyPress = (event) => {
        event.stopPropagation();
    };

    render() {
        return <input {...this.getInputProps()} />;
    }
}

Input.propTypes = {
    className: PropTypes.string,
    defaultValue: PropTypes.string,
    disableAutofill: PropTypes.bool,
    disabled: PropTypes.bool,
    id: PropTypes.string,
    inputType: PropTypes.string,
    name: PropTypes.string.isRequired,
    onBlur: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    size: PropTypes.number,
    value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.number]).isRequired,
};

export default withFormField(Input);
